import * as React from "react";
const ListColGroup = () => /* @__PURE__ */ React.createElement("colgroup", null, /* @__PURE__ */ React.createElement("col", { style: { width: 32 } }), /* @__PURE__ */ React.createElement("col", { style: { width: "70%" } }), /* @__PURE__ */ React.createElement("col", { style: { width: "auto" } }));
export default ListColGroup;
